import * as React from 'react';
import {Query} from 'react-apollo';

import gql from 'graphql-tag';

import type {
    SlackMessagePreviewStage as SlackMessagePreviewStageQuery,
    SlackMessagePreviewStageVariables as SlackMessagePreviewStageQueryVariables,
} from 'nutshell-graphql-types';

type OwnProps = {
    parentId: string;
};

type GraphQLProps = {
    stage: Stage | null | undefined;
};

type Stage = {
    id: string;
    name: string;
    isFirstStage: boolean;
};

type Props = OwnProps & GraphQLProps;

const CLOSED_OUTCOMES = ['LEAD_WON', 'LEAD_LOST', 'LEAD_CANCELLED'];

const GET_SLACK_MESSAGE_PREVIEW_FOR_STAGE = gql`
    query SlackMessagePreviewStage($stageId: ID!) {
        stage(id: $stageId) {
            id
            name
            isFirstStage
        }
    }
`;

function SlackMessagePreviewMessageComponent(props: Props) {
    return <div>{getMessageText(props.parentId, props.stage)}</div>;
}

class SlackPreviewStageQuery extends Query<
    SlackMessagePreviewStageQuery,
    SlackMessagePreviewStageQueryVariables
> {}

export const SlackMessagePreviewMessage = (props: OwnProps) => (
    <SlackPreviewStageQuery
        query={GET_SLACK_MESSAGE_PREVIEW_FOR_STAGE}
        skip={forClosedLeads(props.parentId)}
        variables={{stageId: props.parentId}}
    >
        {({data}) => (
            <SlackMessagePreviewMessageComponent {...props} stage={data ? data.stage : null} />
        )}
    </SlackPreviewStageQuery>
);

function forClosedLeads(parentId: string): boolean {
    return CLOSED_OUTCOMES.includes(parentId);
}

// These messages are meant to match those which the backend
// actually sends (see Nut_Slack_Message).
function getMessageText(parentId: string, stage?: Stage | null) {
    if (stage && stage.isFirstStage) {
        return 'New lead added! 🚀';
    }

    switch (parentId) {
        case 'LEAD_WON':
            return 'Lead won! 💰';
        case 'LEAD_LOST':
            return 'Lead was lost.';
        case 'LEAD_CANCELLED':
            return 'Lead was cancelled.';
        default:
            return stage ? `Lead moved to ${stage.name}` : 'Lead moved to a new stage.';
    }
}
